var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-img',{attrs:{"center":"","alt":"K-9 Logo","src":"https://res.cloudinary.com/dbl4yeqf9/image/upload/v1676427443/logos/logo_corp_fc_egpbiw.png","width":"150","height":"140"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }